// Theme helpers. The initial theme is applied before paint by an inline script in
// __root.tsx (see THEME_INIT_SCRIPT) to avoid a flash of the wrong theme on first load.

export type Theme = "light" | "dark";

export const THEME_STORAGE_KEY = "lsm-theme";

/** Inline, dependency-free script injected into <head> to set the theme before paint. */
export const THEME_INIT_SCRIPT = `(function(){try{var t=localStorage.getItem('${THEME_STORAGE_KEY}');var d=t? t==='dark' : (window.matchMedia&&window.matchMedia('(prefers-color-scheme: dark)').matches);if(d){document.documentElement.classList.add('dark');}}catch(e){}})();`;

/** Resolve the currently-applied theme from the <html> element (client only). */
export function getCurrentTheme(): Theme {
  if (typeof document === "undefined") return "light";
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}

/** Apply a theme to the document and persist the choice. */
export function applyTheme(theme: Theme): void {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle("dark", theme === "dark");
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // ignore — persistence is best-effort
  }
}
